import { Controller } from "@hotwired/stimulus"

export default class RecommendationRotatorController extends Controller {
  static targets = ["item"]
  static values = {
    interval: { type: Number, default: 8000 }
  }

  connect() {
    this.currentIndex = 0
    this.showCurrentItem()
    this.startRotation()
  }

  disconnect() {
    this.stopRotation()
  }

  startRotation() {
    this.timer = setInterval(() => {
      this.next()
    }, this.intervalValue)
  }

  stopRotation() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  next() {
    this.hideCurrentItem()
    this.currentIndex = (this.currentIndex + 1) % this.itemTargets.length
    this.showCurrentItem()
  }

  hideCurrentItem() {
    const item = this.itemTargets[this.currentIndex]
    if (item) {
      item.classList.add("hidden")
    }
  }

  showCurrentItem() {
    const item = this.itemTargets[this.currentIndex]
    if (item) {
      item.classList.remove("hidden")
    }
  }
}
